import { render, staticRenderFns } from "./VehicleConfirmImage.vue?vue&type=template&id=f2d237da&lang=pug&"
import script from "./VehicleConfirmImage.vue?vue&type=script&lang=ts&"
export * from "./VehicleConfirmImage.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleConfirmImage.vue?vue&type=style&index=0&id=f2d237da&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports